module.exports = __webpack_public_path__ + "static/tag-financial-planning-logo-mobile-62ae694d75e4baaa4288bcad930c240b.svg";